import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { fontSizes, fontWeights, spacing, statusColors } from 'syf-component-library/defaultTheme';
import Tooltip from 'syf-component-library/ui/atoms/Tooltip';
import Grid from 'syf-component-library/ui/patterns/Grid/Grid';
import { Body } from 'syf-component-library/ui/typography';
const PROGRESS = 'data-progress';
const PROGRESS_ANIMATION_DURATION = 'data-animation-duration';
const AMOUNT = 'data-amount';
export const Container = styled.div `
  position: relative;
  z-index: -1;
`;
export const AvailableCredit = styled.span `
  display: inline-block;
  text-align: center;
  margin-bottom: ${spacing.large}px;
  color: ${({ theme }) => theme.progressBar.inProgress};
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.xLarge}px;
`;
export const PaymentAmount = styled.span `
  position: absolute;
  left: ${(props) => {
    if (props[AMOUNT] >= 10000) {
        return 'calc(50% + 80px)';
    }
    if (props[AMOUNT] >= 1000) {
        return 'calc(50% + 70px)';
    }
    if (props[AMOUNT] >= 100) {
        return 'calc(50% + 55px)';
    }
    if (props[AMOUNT] >= 10) {
        return 'calc(50% + 45px)';
    }
    return `calc(50% + 35px)`;
}};
  top: 10px;
  color: #3f8429;
  font-weight: ${fontWeights.semiBold};
  font-size: ${fontSizes.root}px;
  transition-delay: ${(props) => props['data-animation-delay']}ms;
  transition-property: transform, opacity;

  ${(props) => {
    const animation = props['data-animation-name'];
    if (animation === 'SHOW') {
        return `
        transition-timing-function: cubic-bezier(0.4, 0, 1, 1), linear;
        transition-duration: 400ms;
        transform: translate3d(0, 0, 0);
        opacity: 1;
      `;
    }
    if (animation === 'HIDE') {
        return `
        transition-timing-function: cubic-bezier(0, 0, 0.58, 1), linear;
        transition-duration: 600ms;
        transform: translate3d(0, -16px, 0);
        opacity: 0;
      `;
    }
    return `
      transform: translate3d(0, 16px, 0);
      opacity: 0;
    `;
}};
`;
export const OuterBarContainer = styled.div `
  width: 100%;
  height: 8px;
  border-radius: 10px;
  background: ${({ theme }) => theme.progressBar.background};
`;
export const InnerBarContainer = styled.div `
  width: ${(props) => (props[PROGRESS] > 100 ? 100 : props[PROGRESS])}%;
  transition-property: width;
  transition-duration: ${(props) => props[PROGRESS_ANIMATION_DURATION]}ms;
  transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  height: 8px;
  border-radius: 10px;
  background: ${({ theme }) => theme.progressBar.inProgress};
`;
export const LegendWrapper = styled.div `
  display: flex;
  margin-top: ${spacing.base}px;
  justify-content: space-between;
`;
export const AmountDetailsContainer = styled.div `
  display: flex;
  flex-direction: column;
  &:last-child {
    text-align: end;
  }
`;
export const AvailableCreditContainer = styled(Grid) `
  width: 100%;
`;
export const AvailableCreditHeader = styled(Grid) `
  display: flex;
  justify-content: center;
`;
export const AvailableCreditTooltip = styled(Tooltip) `
  font-weight: ${fontWeights.regular};
`;
export const AvailableCreditBody = styled(Body) `
  display: flex;
  align-items: center;
  gap: ${spacing.xsmall}px;

  @media ${query.greaterThanMedium} {
    font-size: ${fontSizes.medium}px;
  }
`;
export const TooltipContainer = styled.span `
  display: flex;
  align-items: center;
  color: ${statusColors.info.icon};
`;
